import React, { lazy, Suspense } from 'react';
import {
  Route,
  Redirect,
  BrowserRouter as Router,
  Switch,
} from 'react-router-dom';
import {useSelector} from 'react-redux';
import authHelper from "./library/helpers/authHelper";
import ErrorBoundary from './ErrorBoundary';
import { PUBLIC_ROUTE } from './route.constants';
import Loader from '@ease/components/utility/loader';
const Dashboard = lazy(() => import('./containers/dashboard/Dashboard'));

const publicRoutes = [
  {
    path: PUBLIC_ROUTE.LANDING,
    exact: true,
    component: lazy(() => import('@ease/containers/auth/SignIn/SignIn')),
  },
  /*{
    path: PUBLIC_ROUTE.PAGE_404,
    component: lazy(() => import('@ease/containers/Pages/404/404')),
  },
  {
    path: PUBLIC_ROUTE.PAGE_500,
    component: lazy(() => import('@ease/containers/Pages/500/500')),
  },*/
  {
    path: PUBLIC_ROUTE.SIGN_IN,
    component: lazy(() => import('@ease/containers/auth/SignIn/SignIn')),
  },
  {
    path: PUBLIC_ROUTE.SIGN_UP,
    component: lazy(() => import('@ease/containers/auth/SignUp/SignUp')),
  },
  {
    path: PUBLIC_ROUTE.FORGET_PASSWORD,
    component: lazy(() =>
      import('@ease/containers/auth/ForgotPassword/ForgotPassword')
    ),
  },
  {
    path: PUBLIC_ROUTE.RESET_PASSWORD,
    component: lazy(() =>
      import('@ease/containers/auth/ResetPassword/ResetPassword')
    ),
  },
  /*{
    path: PUBLIC_ROUTE.AUTH0_CALLBACK,
    component: lazy(() =>
      import('@ease/containers/Authentication/Auth0/Auth0Callback')
    ),
  }*/
];
function PrivateRoute({ children, ...rest }) {
  let token = useSelector((state) => state.Auth.idToken);
  const auth = authHelper.checkExpirity(token);
  return (
    <Route
      {...rest}
      render={({ location }) =>
          auth===true ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/signin',
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

export default function Routes() {
  return (
    <ErrorBoundary>
      <Suspense fallback={<Loader />}>
        <Router>
          <Switch>
            {publicRoutes.map((route, index) => (
              <Route key={index} path={route.path} exact={route.exact}>
                <route.component />
              </Route>
            ))}
            <PrivateRoute path="/dashboard">
              <Dashboard />
            </PrivateRoute>
          </Switch>
        </Router>
      </Suspense>
    </ErrorBoundary>
  );
}
